import { Role } from "./Roles";
import { getLocalValue } from "../utils/auth";

export const sessionPath = (preferPersonal) => {
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  const uRole = parseInt(getLocalValue("u_role"));
  let URL = "/sessions/personal";
  switch (coachingRole) {
    case 0:
      if (uRole === Role.COACH && !preferPersonal) {
        URL = "/sessions/teams";
      } else {
        URL = "/sessions/personal";
      }
      break;
    case Role.CAMPAIGN_MANAGER:
      URL = "/sessions/campaign";
      break;
    case Role.COORDINATOR:
      URL = "/sessions/campaign";
      break;
    case Role.SUPPORT_ADMIN:
      URL = "/sessions/support";
      break;
    default:
      URL = "/sessions/personal";
  }

  return URL;
};

export const teamPath = () => {
  let URL = "/teams";
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  switch (coachingRole) {
    case Role.COACH:
      URL = "/teams";
      break;
    case Role.CAMPAIGN_MANAGER:
      URL = "/teams/campaign";
      break;
    case Role.COORDINATOR:
      URL = "/teams";
      break;
    case Role.SUPPORT_ADMIN:
      URL = "/teams/supportAdmin";
      break;
    default:
      URL = "/teams";
  }
  return URL;
};

export const logsPath = () => {
  let URL = "/logs/personal";
  const coachingRole = parseInt(getLocalValue("u_coaching_role"));
  const uRole = parseInt(getLocalValue("u_role"));
  switch (coachingRole) {
    case 0:
      if (uRole === Role.COACH) {
        URL = "/logs/team";
      } else {
        URL = "/logs/personal";
      }
      break;

    case Role.CAMPAIGN_MANAGER:
      URL = "/logs/campaign";
      break;
    case Role.COORDINATOR:
      URL = "/logs/campaign";
      break;
    case Role.SUPPORT_ADMIN:
      URL = "/logs/support";
      break;
    default:
      URL = "/logs/personal";
  }

  return URL;
};
